.dda-avatar {
  display: inline-flex;
  position: relative;
  align-items: center;
  justify-content: center;
}

.avatar-shape-circle {
  border-radius: 64px;
}

.avatar-shape-square {
  border-radius: 8px;
}

.avatar-type-photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-type-photo.avatar-shape-circle img {
  border-radius: 64px;
}

.avatar-type-photo.avatar-shape-square img {
  border-radius: 8px;
}


.avatar-type-icon {
  background: var(--dda-neutral-variant-94);
  text-align: center;
}

.avatar-type-icon .dda-smile path {
  fill: var(--dda-neutral-variant-30);
}

.avatar-type-icon i {
  color: var(--dda-neutral-variant-30);
}

.avatar-type-icon.avatar-size-xs .dda-smile {
  font-size: 13px;
}

.avatar-type-icon.avatar-size-sm .dda-smile {
  font-size: 19px;
}

.avatar-type-icon.avatar-size-md .dda-smile {
  font-size: 24px;
}

.avatar-type-icon.avatar-size-lg .dda-smile {
  font-size: 28px;
}

.avatar-type-icon.avatar-size-xl .dda-smile {
  font-size: 31px;
}

.avatar-type-icon.avatar-size-xxl .dda-smile {
  font-size: 37px;
}


.avatar-type-text {
  background: var(--dda-color-primary-40);
  text-align: center;
}

.light-mode.avatar-type-text{
  background: var(--dda-primary-40);
}

.avatar-type-text .avatar-main-text {
  color: var(--dda-neutral-100);
  font-size: 16px;
}

.avatar-size-xs .avatar-main-text {
  font-size: 10px;
}

.avatar-size-sm .avatar-main-text {
  font-size: 12px;
}

.avatar-size-md .avatar-main-text {
  font-size: 16px;
}

.avatar-size-lg .avatar-main-text {
  font-size: 20px;
}

.avatar-size-xl .avatar-main-text {
  font-size: 24px;
}

.avatar-size-xxl .avatar-main-text {
  font-size: 28px;
}


.avatar-size-xs {
  width: 24px;
  height: 24px;
}

.avatar-size-sm {
  width: 32px;
  height: 32px;
}

.avatar-size-md {
  width: 40px;
  height: 40px;
}

.avatar-size-lg {
  width: 48px;
  height: 48px;
}

.avatar-size-xl {
  width: 56px;
  height: 56px;
}

.avatar-size-xxl {
  width: 64px;
  height: 64px;
}


.dda-avatar .status-circle {
  width: 12px;
  height: 12px;
  border-radius: 20px;
  background: var(--dda-color-success-40);
  border: solid 2px var(--dda-neutral-100);
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.04);
  position: absolute;
  bottom: -2px;
  right: -2px;
}

.light-mode.dda-avatar .status-circle{
  background: var(--dda-success-40);
}

.avatar-size-xs .status-circle {
  width: 8px;
  height: 8px;
}

.avatar-size-sm .status-circle {
  width: 12px;
  height: 12px;
}

.avatar-size-md .status-circle {
  width: 14px;
  height: 14px;
}

.avatar-size-lg .status-circle {
  width: 16px;
  height: 16px;
}

.avatar-size-xl .status-circle {
  width: 18px;
  height: 18px;
}

.avatar-size-xxl .status-circle {
  width: 20px;
  height: 20px;
}


.dda-avatar .verified-icon {
  display: flex;
  background-color: var(--dda-neutral-100);
  color: var(--dda-color-success-40);
  border-radius: 20px;
  border: solid 2px var(--dda-neutral-100);
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.04);
  position: absolute;
  bottom: -2px;
  inset-inline-end: -2px;
}

.light-mode.dda-avatar .verified-icon{
  color: var(--dda-success-40);
}

.dda-avatar.avatar-size-xs .verified-icon span {
  font-size: 6px;
}

.dda-avatar.avatar-size-sm .verified-icon span {
  font-size: 8px;
}

.dda-avatar.avatar-size-md .verified-icon span {
  font-size: 10px;
}

.dda-avatar.avatar-size-lg .verified-icon span {
  font-size: 12px;
}

.dda-avatar.avatar-size-xl .verified-icon span {
  font-size: 14px;
}

.dda-avatar.avatar-size-xxl .verified-icon span {
  font-size: 16px;
}


.avatar-design-live {
  box-shadow: 0px 0px 0px 2px var(--dda-neutral-100), 0px 0px 0px 4px var(--dda-color-primary-40);
}

.light-mode.avatar-design-live{
  box-shadow: 0px 0px 0px 2px var(--dda-neutral-100), 0px 0px 0px 4px var(--dda-primary-40);
}

.notification-circle {
  width: auto;
  height: 20px;
  background: var(--dda-color-error-40);
  font-size: var(--dda-fs-body-sm);
  color: var(--dda-neutral-100);
  padding: 0 8px;
  border: solid 2px var(--dda-neutral-100);
  border-radius: 40px;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.04);
  display: inline-grid;
  align-items: center;
  position: absolute;
  top: -5px;
  right: -10px;
}

.light-mode .notification-circle{
  background: var(--dda-error-40);
}

.avatar-size-xs .notification-circle,
.avatar-size-sm .notification-circle {
  width: 14px;
  height: 14px;
  padding: 0px;
  text-indent: -100px;
  overflow: hidden;
  top: -5px;
  right: -5px;
}

.avatar-size-md .notification-circle {
  height: 20px;
}

.avatar-size-lg .notification-circle {
  height: 22px;
}

.avatar-size-xl .notification-circle {
  height: 24px;
}

.avatar-size-xxl .notification-circle {
  height: 24px;
}

